module.exports = __webpack_public_path__ + "img/move.962b6180.png";